<template>
  <div class="header">
    <div class="h_center">
      <div class="logo" @click="linkToHome">
        <img src="../../assets/logo.png" alt="">
      </div>
      <ul class="h_nav">
        <li class="h_n_list" :class="{'add_h_n_list' :navacitive==index}" v-for="(item,index) in navList" :key="index"
          @click="navroute_func(item.path,index)">
          {{item.title}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data() {
      return {
        navacitive: 0,
        // navList: [
        //     {'id':0,'title':'首页',"path":'/'},
        //     {'id':0,'title':'业务范围',"path":'/busines'},
        //     {'id':0,'title':'公司简介',"path":'/brief'},
        //     {'id':0,'title':'工程案例',"path":'/casecenter'},
        //     {'id':0,'title':'新闻中心',"path":'/newscenter'},
        //     {'id':0,'title':'人才招聘',"path":'/talent'},
        //     {'id':0,'title':'联系我们',"path":'/concat'}
        // ]
      }
    },
    props: {
      navList: Array
    },
    methods: {
      navroute_func(path, index) {
        this.$router.push({
          'path': path
        });
        this.navacitive = index;
      },
      linkToHome() {
        this.$router.push({
          'path': '/'
        });
        this.navacitive = 0;
      },
      setNavactive() {
        let path = this.$route.path;
        switch (path) {
          case '/busines':
            this.navacitive = 1;
            break;
          case '/brief':
            this.navacitive = 2;
            break;
          case '/casecenter':
            this.navacitive = 3;
            break;
          case '/newscenter':
            this.navacitive = 4;
            break;
          case '/talent':
            this.navacitive = 5;
            break;
          case '/concat':
            this.navacitive = 6;
            break;
          case '/':
            this.navacitive = 0;
            break;
          default:
            this.navacitive = 0;
            break;
        }

      }
    },

    mounted() {
      this.setNavactive();
      //   this.navList =  this.$store.state.navList;
      //   console.log('this.navList',this.navList,this.$store.state.navList);
    },

  }
</script>

<style scoped lang="scss">
  .header {
    width: 100%;
    height: 120px;
    background: #ffffff;

    .h_center {
      // border: 1px solid red;
      width: 1200px;
      height: 120px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        width: 180px;
        height: 74px;

        img {
          width: 180px;
          height: 74px;
        }
      }

      .h_nav {
        // border: 1px solid red;
        width: 900px;
        height: 120px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .h_n_list {
          border-bottom: 2px solid #ffffff;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #666666;
          font-size: 16px;
          cursor: pointer;
        }

        .h_n_list:hover {
          border-bottom: 2px solid #1584F5;
          color: #1584F5;
        }

        .add_h_n_list {
          border-bottom: 2px solid #1584F5;
          color: #1584F5;
        }
      }
    }
  }
</style>